import React from 'react';
import { compose } from 'redux';
import PropTypes from 'prop-types';
import loadable from '@loadable/component';
import { INSPECTION_INFO_STATUS } from 'Constants/items';
import { isMobile } from 'Helpers/devices';
import withConfig from 'HOCs/withConfig/withConfig';

const AdpvMX = loadable(() => import(/* webpackChunkName: "AdpvMX" */'./AdpvMXContainer'));
const AdpvAuto = loadable(() => import(/* webpackChunkName: "AdpvAuto" */'./AdpvAuto.APP_TARGET'));
const AdpvOld = loadable(() => import(/* webpackChunkName: "AdpvOld" */'./AdpvOld.APP_TARGET'));

export const ItemContent = props => {
    const { item, config } = props;

    const itemId = item?.id;
    const adpvConfig = config.get('adpvAuto');
    const isNewAdpvConfigEnabled = config.get('adpvAuto', 'enable');
    const carCategory = config.get('adpvAuto', 'carCategory');
    const showNewDesign = config.get('adpvAuto', 'showMXDesign') || config.get('adpvAuto', 'showNewDesign');
    const isItemInspected = item.inspection_info
        && item.inspection_info.inspection_id
        && item.inspection_info.consent === INSPECTION_INFO_STATUS.APPROVED;

    const isNewAdpvPlatformEnabled = showNewDesign || isMobile || isItemInspected;
    const isCarCategory = carCategory && item.category_id == carCategory;

    const shouldRenderNewADPV = isNewAdpvConfigEnabled && isNewAdpvPlatformEnabled && isCarCategory;

    let AdpvComponent = null;

    if (shouldRenderNewADPV) {
        AdpvComponent = showNewDesign ? AdpvMX : AdpvAuto;
    }
    else {
        AdpvComponent = AdpvOld;
    }

    return (<AdpvComponent showNewDesign={ adpvConfig.showNewDesign }
        itemId={ itemId }
        { ...props } />);
};

ItemContent.propTypes = {
    item: PropTypes.object.isRequired,
    variant: PropTypes.string,
    config: PropTypes.shape({
        get: PropTypes.func.isRequired
    }).isRequired,
    loggedUser: PropTypes.shape({
        id: PropTypes.string
    })
};

export default compose(
    withConfig
)(ItemContent);
